
import React, {Component, useState, useEffect, Fragment} from 'react';
import axios from 'axios';
import ReactAppointmentsCard from './ReactAppointmentsCard.jsx';
import PropTypes from 'prop-types';
const CLS = 'reactAppointmentsContainer';

const SELECT = { //#TODO: need to confirm this
	LATEST: 'latest',
	OLDEST: 'oldest',
}

const ReactAppointmentsContainer = (props) => {
	const [upcomingAppointments, setUpcomingAppointments] = useState([]);
	const [pastAppointments, setPastAppointments] = useState([]);
	const [active, setActive] = useState(0);
	const [sortby, setSortBy] = useState(SELECT.LATEST)

	const {
		upcomingApi,
		pastApi,
		upcomingText,
		pastText
	} = props;

	/**
	 *
	 * @param {String} endPoint : api endpoint
	 * @param {Object} options : filter option
	 * @param {func} setData : set response through functionn
	 */

	const getData = (endPoint, options = null, setData) => {
		axios.get(endPoint, options)
		.then((res) => {
			console.log(res);
			if(res.statusText === 'OK'
				&& res.data
				&& res.data.Appointments
				&& res.data.Appointments.length > 0) {
				setData(res.data.Appointments);
			}
		});
	}

	useEffect(() => {
		// fetch upcoming appointment api
		upcomingApi && !upcomingAppointments.length && getData(upcomingApi, null, setUpcomingAppointments);
	}, []);

	useEffect(() => {
		// fetch past appointment api
		const options = {
			params: {
				sort: sortby
			}
		}
		pastApi && getData(pastApi, options, setPastAppointments);
	}, [sortby]);

	const renderDropDown = () => (
		<Fragment>
			<span className={`${CLS}-sort-label text-dark d-block`}>Sort</span>
			<div className={`${CLS}-dropdown dropdown`}>
				<button className={`${CLS}-dropdown-toggle dropdown-toggle btn-sm`} type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
					{sortby}
				</button>
				<div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
					{Object.values(SELECT).map((item, index) => (<a className="dropdown-item" key={`dropdown-${index}`} href="#" onClick={() => {setSortBy(item)}}>{item}</a>))}
				</div>
			</div>
		</Fragment>
	)
	return (
		<Fragment>
			<ul className={`${CLS}-nav nav nav-tabs`} role="tablist">
				<li className={`${CLS}-nav-item nav-item`}>
					<a className={`${CLS}-nav-link nav-link ${active == 0 ? 'active show' : ''}`} id="upcoming-tab" data-toggle="tab" href="#upcoming" role="tab" aria-controls="upcoming" aria-selected={active == 0 ? "true": "false"} onClick={() =>setActive(0)}>{upcomingText}</a>
				</li>
				<li className="nav-item">
					<a className={`${CLS}-nav-link nav-link ${active == 1 ? 'active show' : ''}`} id="past-tab" data-toggle="tab" href="#past" role="tab" aria-controls="past"  aria-selected={active == 1 ? "true": "false"} onClick={() =>setActive(1)}>{pastText}</a>
				</li>
			</ul>
			<div className="row">
				<div className="tab-content mt-3 col-12 col-md-10 col-lg-8">
					<div className={`tab-pane fade ${active == 0 ? 'active show' : ''}`} id="upcoming" role="tabpanel" aria-labelledby="upcoming-tab">
						{
							upcomingAppointments.length > 0 &&
							upcomingAppointments.map((e, i) => {
								return (
									<ReactAppointmentsCard
										key={i}
										{...e}
										onCancelClick={()=>{console.log('onCancelClick')}}
										onEditClick={()=>{console.log('onEditClick')}}
										onJoinCallClick={()=>{console.log('onJoinCallClick')}}
										onSetReminderClick={()=>{console.log('onSetReminderClick')}}
										isUpcoming
									/>
									)
								})
						}
					</div>
					<div className={`tab-pane fade ${active == 1 ? 'active show' : ''}`} id="past" role="tabpanel" aria-labelledby="past-tab">
						{renderDropDown()}
						{
							pastAppointments.length > 0 &&
							pastAppointments.map((e, i) => {
								return (
									<ReactAppointmentsCard
										key={i}
										{...e}
										onFeedbackClick={()=>{console.log('onFeedbackClick')}}
									/>
								)
							})
						}
					</div>
				</div>
			</div>
		</Fragment>
	);
};

ReactAppointmentsContainer.propTypes = {
	/** End point for past content */
	pastApi: PropTypes.string.isRequired,
	/** End point for upcoming content */
	upcomingApi: PropTypes.string.isRequired
};

ReactAppointmentsContainer.defaultProps = {
	upcomingText: "upcoming",
	pastText: "past"
};
export default ReactAppointmentsContainer;
